/* STUB IMPLEMENTATION — see src/stubs/README.md.
 *
 * In a deployment the entry point comes from the host: the account console is
 * served from the provider's domain, a cluster console from a tenancy's. On a
 * development machine everything is `localhost`, so the two have to be
 * reachable some other way — and that other way must not exist in a build that
 * talks to a real server, or it would be a way to ask the application to be
 * the console it is not.
 *
 * It lives here for exactly that reason: this directory is deleted whole, and
 * with it the only code that lets an entry point be chosen rather than served.
 */

import type { EntryPoint } from '../entry/entryPoint';

const KEY = 'gdsgate.stub.entry';

/** The tenancy the demonstration cluster console belongs to. */
export const STUB_TENANCY_DOMAIN = 'acme.gate.example';

export type StubEntryKind = 'account' | 'cluster';

export function resolveStubEntryPoint(): EntryPoint {
  const asked = new URLSearchParams(window.location.search).get('entry');
  if (asked === 'account' || asked === 'cluster') {
    sessionStorage.setItem(KEY, asked);
  }

  return sessionStorage.getItem(KEY) === 'cluster'
    ? { kind: 'cluster', tenancyDomain: STUB_TENANCY_DOMAIN }
    : { kind: 'account' };
}

/** Switching entry points reloads: in a deployment it is a different origin. */
export function switchStubEntry(kind: StubEntryKind): void {
  sessionStorage.setItem(KEY, kind);
  window.location.assign(`/?entry=${kind}`);
}
